module.exports = __webpack_public_path__ + "img/products.8b3aba8e.svg";